module.exports = __webpack_public_path__ + "static/img/img_agenting.133dd80.133dd80b.jpg";